export default {"src":"/_next/static/media/content_audio.8ec16529.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};